import { Fragment } from "react"

export interface TemplateKeyMap {
  [key: string]: string
}

// Replaces '%template%' in template with associated value in replacements ({template: value}) for each template in replacements
export function resolveTemplateWithObject(
  template: string | null | undefined,
  replacements: TemplateKeyMap,
) {
  const list = Object.keys(replacements)
  return list && template
    ? list.reduce(
      (acc, cur) => (acc = acc.replace(/%.*%/, replacements[cur])),
      template,
    )
    : template;
}

export function insertLineBreaks(template: string | null | undefined) {
  return template?.split("%n%")?.map((x, idx) => (
    <Fragment key={idx}>
      {x}
      <br />
    </Fragment>
  ))
}
